<template>
  <div>
    <div ref="richTextWithModalRef" v-html="field?.value" />

    <ModalDialog v-model="showModal" :showXCloseButton="true" :closeOnEsc="true" size="tooltip">
      <div v-html="modalContent" />
    </ModalDialog>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import ModalDialog from '@/components/ModalDialog/ModalDialog.vue';
import { Field } from '@sitecore-jss/sitecore-jss/types/layout';

const props = defineProps<{
  field: Field<string>; // Sitecore RichText field
  modalContentHtml: any; // Sitecore RichText field
}>();

const showModal = ref(false);
const modalContent = ref('');
const richTextWithModalRef = ref<HTMLElement | null>(null);

const handleClick = (event: Event) => {
  const target = event.target as HTMLElement;
  const link = target.closest('.open-modal');
  if (link && link instanceof HTMLElement) {
    event.preventDefault();
    modalContent.value = props.modalContentHtml?.value; //link.dataset.modalContent || 'RACQ modal content';
    showModal.value = true;
  }
};

onMounted(() => {
  richTextWithModalRef.value?.addEventListener('click', handleClick);
});

onBeforeUnmount(() => {
  richTextWithModalRef.value?.removeEventListener('click', handleClick);
});
</script>
